module.exports = "pegasus/assets/hexline-twitter.gif";